import type {IconPrefix} from '@fortawesome/fontawesome-common-types';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

const FA_ICON_PREFIXES: Array<IconPrefix> = [`fas`, `far`, `fal`, `fat`, `fad`, `fab`, `fak`, `fass`, `fasr`, `fasl`];

export const isFontAwesomeIcon = (icon: any): icon is IconDefinition => {
  const prefix = icon?.prefix;
  return FA_ICON_PREFIXES.includes(prefix);
};
